<template>
    <div>
         <con-tab @TwoClick="TwoClick"></con-tab>
        <!--底部-->
        <Button ></Button>
    </div>
</template>

<script>
    import ConTab from "../../components/common/ConTab";
    import Button from "./base/Button.vue";
    // import Qs from 'qs'
    export default {
        name: "Kefuyun",
        data(){
            return {
                
            }
        },
        created(){
            
        },
        methods:{
             TwoClick(item){
                //console.log(item);
                this.ConList = item
            },
        },
        components:{
            ConTab,
            Button
        }
    }
</script>

<style scoped>

</style>
